<template>
  <v-alert class="mb-0 mt-4" type="success" color="deep-purple lighten-1" prominent>
    <v-row align="center">
      <v-col class="grow">
        {{ message }}
      </v-col>
      <v-col class="shrink">
        <v-btn @click="verse_dialog = true">
          Click Here
        </v-btn>
      </v-col>
    </v-row>
  
    <!-- Response Dialog -->
    <v-dialog v-model="verse_dialog" max-width="500px">
      <v-card>
        <v-card-title class="justify-center">
          Verses
        </v-card-title>
        <v-card-subtitle class="text-center pb-4">
          Needs text.
        </v-card-subtitle>
        <v-divider></v-divider>
        <v-card-text>
          <p class="text-body-1" v-for="(verse, index) in verses" :key="'verse-' + index">
            {{ verse.verse }}<br>
            <small class="text-caption">
              {{ verse.source }}
            </small>
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-alert>
</template>
<script>
import christian_verses from '../include/christian-verses.json';

export default {
  name: 'ChristianAlert',
  props: ['message', 'major_issue'],
  data: () => ({
    verse_dialog: false,
  }),
  computed: {
    verses: function() {
      return christian_verses.filter(v => v.major_issue === this.major_issue);
    }
  },
  mounted() {
    //this.verses = christian_verses;
  }
}
</script>